export function DelegatedButton({ operation, delegations, isClient, overrideActive, onClick, children, style, disabled, ...rest }) {
  if (isClient) {
    return <button onClick={onClick} style={style} disabled={disabled} {...rest}>{children}</button>;
  }

  const loading = delegations === null;
  const allowed = overrideActive || delegations?.[operation];

  const borderColor = overrideActive ? '#ff8800' : (allowed ? '#00cc66' : undefined);
  const labelSuffix = overrideActive
    ? <span style={{ color: '#ff8800', fontSize: '0.8em' }}> OVERRIDE</span>
    : allowed
      ? <span style={{ color: '#00cc66', fontSize: '0.8em' }}> </span>
      : null;

  return (
    <button
      onClick={allowed && !disabled ? onClick : undefined}
      title={allowed ? undefined : 'El cliente no ha delegado esta operación'}
      style={{
        ...style,
        opacity: loading ? 0.3 : (allowed ? 1 : 0.45),
        cursor: (allowed && !disabled) ? 'pointer' : 'not-allowed',
        border: borderColor ? `1px solid ${borderColor}` : (style?.border || '1px solid var(--border)'),
      }}
      disabled={!allowed || disabled}
      {...rest}
    >
      {loading ? '...' : allowed ? <>{children}{labelSuffix}</> : '🔒 BLOQUEADO'}
    </button>
  );
}
